import React, { useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styles from './VerifyToken.module.css';
import Footer from '../../common/UI/Footer';
import { useNavigate, useParams } from 'react-router-dom';
import { useForgotPassword } from '../../hooks/useForgetpassword';

const VerifyToken = () => {
  const { verifyToken, isLoading, error } = useForgotPassword();
  const navigate = useNavigate();
  const { token } = useParams();

  useEffect(() => {
    const verifyResetToken = async () => {
      try {
        await verifyToken(token, {
          onSuccess: () => {
            navigate(`/reset-password/${token}`);
          },
          onError: (err) => {
            toast.error(err?.response?.data?.message || 'Invalid or expired token');
            setTimeout(() => {
              navigate('/forgot-password');
            }, 3000);
          }
        });
      } catch (err) {
        console.error('Error verifying token:', err);
      }
    };

    if (token) {
      verifyResetToken();
    }
  }, [token, verifyToken, navigate]);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <div className={styles.container}>
        <div className={styles.formCard}>
          <h2>Verifying Reset Link</h2>
          <div className={styles.loadingWrapper}>
            <Loader2 className={styles.spinner} size={40} />
            <p className={styles.loadingText}>Please wait while we verify your reset link...</p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default VerifyToken;